import React from 'react'
import OrgLocMappingMasterComponent from '../Components/OrganizationMaster/OrgLocMappingMasterComponent'

const OrgLocMappingMasterPage = () => {
  return (
    <div><OrgLocMappingMasterComponent/></div>
  )
}

export default OrgLocMappingMasterPage